// extracted by mini-css-extract-plugin
export default {"list":"MobileNav_list__CFVnX","link":"MobileNav_link__XOaDy","active":"MobileNav_active__w0795"};